// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthForm_auth__1zLFQ","control":"AuthForm_control__2xV3J","actions":"AuthForm_actions__1k1Cd","toggle":"AuthForm_toggle__2kLSS"};